import { custom } from 'owa-locstrings/lib/strings/custom.locstring.json';
import { repeatYearly } from 'owa-locstrings/lib/strings/repeatyearly.locstring.json';
import { repeatMonthly } from 'owa-locstrings/lib/strings/repeatmonthly.locstring.json';
import { repeatWeekly } from 'owa-locstrings/lib/strings/repeatweekly.locstring.json';
import { repeatDaily } from 'owa-locstrings/lib/strings/repeatdaily.locstring.json';
import { repeatNever } from 'owa-locstrings/lib/strings/repeatnever.locstring.json';
import loc from 'owa-localize';

import RecurrenceConstants from 'owa-recurrence-utils/lib/RecurrenceTypes';
import { IDropdownOption } from '@fluentui/react/lib/Dropdown';
import { SelectableOptionMenuItemType } from '@fluentui/react/lib/SelectableOption';

// Contains all the base options for the recurrence
const getRecurrenceMenuItems = (
    customRecurrenceString: string,
    isNeverDisabled: boolean
): IDropdownOption[] => {
    return [
        {
            key: RecurrenceConstants.None,
            text: loc(repeatNever),
            disabled: isNeverDisabled,
        },
        {
            key: RecurrenceConstants.Daily,
            text: loc(repeatDaily),
        },
        {
            key: RecurrenceConstants.Weekly,
            text: loc(repeatWeekly),
        },
        {
            key: RecurrenceConstants.Monthly,
            text: loc(repeatMonthly),
        },
        {
            key: RecurrenceConstants.Yearly,
            text: loc(repeatYearly),
        },
        {
            key: 'divider_RecurrenceMenuItems',
            text: '-',
            itemType: SelectableOptionMenuItemType.Divider,
        },
        {
            key: RecurrenceConstants.Custom,
            text: customRecurrenceString || loc(custom),
        },
    ];
};

export default getRecurrenceMenuItems;
